import BaseModel from "nexia_mobile/models/base_model";
import LocalSettings from "nexia_mobile/models/local_settings";
import { setValueAtPath } from "nexia_mobile/flux_like/store";

export default class AppState extends BaseModel {
  get currentLocation() {
    return this.get("currentLocation");
  }
  set currentLocation(value) {
    return this.set("currentLocation", value);
  }
  resetCurrentLocation() {
    this.currentLocation = null;
  }

  get userAuthenticated() {
    return this.get("userAuthenticated");
  }
  set userAuthenticated(value) {
    return this.set("userAuthenticated", value);
  }

  get inDemoMode() {
    return this.get("inDemoMode");
  }
  set inDemoMode(value) {
    return this.set("inDemoMode", value);
  }

  get isFirstVisit() {
    return this.get("isFirstVisit");
  }

  set isFirstVisit(value) {
    return this.set("isFirstVisit", value);
  }

  get needsAuthentication() {
    return LocalSettings.needsAuthentication();
  }

  initialize() {
    super.initialize();
    this._setUpListeners();
    this._backgroundLoadingRequestMap = {};
    this.currentLocation = null;
    this._resetUserAuthenticatedState();
  }

  _resetUserAuthenticatedState() {
    this.userAuthenticated = LocalSettings.canSkipLogin() || this.inDemoMode;
  }

  _setUpListeners() {
    this.listenTo(LocalSettings, "activation:success", () => {
      if (!LocalSettings.needsAuthentication()) {
        this.userAuthenticated = true;
      }
    });

    this.listenTo(BaseModel.Events, "request", (model, xhr, options) => {
      if (!(options.useBackgroundLoadingIndicator && model.id)) {
        return;
      }

      this._backgroundLoadingRequestMap[model.id] = true;
      this._updateBackgroundLoading();
    });

    this.listenTo(
      BaseModel.Events,
      "sync error",
      (model, response, options) => {
        if (!(options.useBackgroundLoadingIndicator && model.id)) {
          return;
        }
        if (this._backgroundLoadingRequestMap[model.id]) {
          delete this._backgroundLoadingRequestMap[model.id];
        }
        this._updateBackgroundLoading();
      }
    );
  }

  _updateBackgroundLoading() {
    if (Object.keys(this._backgroundLoadingRequestMap).length > 0) {
      setValueAtPath("backgroundLoading", true);
    } else {
      setValueAtPath("backgroundLoading", false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/app_state.js